import React from "react";
import { bool, object, string } from "prop-types";

import LiveText from "../LiveText";
import Icons, { SvgIcon } from "../../icons";
import Anchor from "../Anchor";

import { getHeadline } from "../../utils/utils";

import "./newsHeadline.m.css";

const NewsHeadline = ({
  cssStyleName,
  story = {},
  showDot = false,
  styles = {},
  showSubHeading = true,
  linkEnable = true,
  Htag = "h3",
  iconEnd = false,
  className = "",
  showSponsor = true,
}) => {
  const sponsorId = showSponsor && story.metadata?.["story-attributes"]?.sponsoredby?.["0"]?.id;
  const storyHeadline = getHeadline(story);
  const isClosed = story.metadata?.["is-closed"];
  const liveBlog = story["story-template"] === "live-blog";
  const { access, url = "", subheadline = "", "story-template": type } = story;

  const sholderWrapper = (children) => (
    <span className="sub-title" styleName="sub-title-text">
      {children}
    </span>
  );

  const defaultIcons = { interview: "interview", audio: "audio" };

  const headlineLayout = (
    <span className="tilte-no-link-parent">
      {access === "login" && <Icons type="star" styleName="sponsor" className="sponsor-icon" />}
      {sponsorId && <Icons type="sponsor" styleName="sponsor" className="sponsor-icon" />}
      {liveBlog && !isClosed
        ? sholderWrapper(<LiveText isClosed={isClosed} lastPublishedAt={story["last-published-at"]} />)
        : showSubHeading && subheadline && sholderWrapper(String(subheadline).trim())}

      {" " + String(storyHeadline).trim()}

      <SvgIcon styleName="icon" className="headline-icon" type={iconEnd ? type : defaultIcons[type]} />
    </span>
  );

  const dot = (!liveBlog || (liveBlog && isClosed)) && showDot && styles;

  const dotBgColor = styles?.dotColor?.color;

  return (
    <div className="card-with-image-zoom">
      <Htag
        className={`headline-title ${sponsorId ? "sponsor-title" : ""} ${className}`}
        styleName={`title ${cssStyleName || ""} ${dot ? "dot-show" : ""}`}
      >
        {dot && (
          <span styleName="s-dot" style={{ background: dotBgColor !== "4d" ? dotBgColor : "#ccc" }}>
            &nbsp;
          </span>
        )}
        {linkEnable ? (
          <Anchor aria-label={subheadline || "Title link"} href={url} className="title-link">
            {headlineLayout}
          </Anchor>
        ) : (
          headlineLayout
        )}
      </Htag>
    </div>
  );
};

NewsHeadline.propTypes = {
  cssStyleName: string,
  story: object,
  showDot: bool,
  styles: object,
  showSubHeading: bool,
  linkEnable: bool,
  iconEnd: bool,
  Htag: string,
  className: string,
  showSponsor: bool,
};

export default NewsHeadline;
